export const ALL_CLIENTS = "/client/list";
export const CREATE_CLIENT = "/client/create";
export const UPDATE_CLIENT = "/client/update";
export const DELETE_CLIENT = "/client/delete";
export const GET_CLIENT_BY_ID = "/client/detail";
export const ADD_CLIENT = "/client/add";
